
import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvasForm = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      if(this.title.main.visible == 'Y') {
        this.canvasForm
        .append('text')
        .attr('transform', `translate(${this.title.main.x}, ${this.title.main.y + this.title.main.tSize*0.27})`)
        .style('font-size', this.title.main.tSize)
        .style('fill', this.title.main.tColor)
        .text(this.title.main.name)
      }

      if(this.title.sub.visible == 'Y') {
        this.canvasForm
        .append('text')
        .attr('transform', `translate(${this.title.sub.x}, ${this.title.sub.y + this.title.sub.tSize*0.27})`)
        .style('font-size', this.title.sub.tSize)
        .style('fill', this.title.sub.tColor)
        .text(this.title.sub.name)
      }


      this.draw_Legends()
      this.draw_Timeline_Week_Custom()
      this.draw_SkylineCharts(this.filteredData)


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    
    },


  }
}